/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar, Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const RevenueBusinessBarLineChart = ({ datasets, chartData, title }) => {
  const data = {
    labels: chartData.map((item) => item.label),
    datasets: datasets,
  };

  const options = {
    // indexAxis: indexAxis,
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,
      },
    },
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10
          },
        },

        // onClick(e) {
        //   if (e.stopPropagation) e.stopPropagation();
        // },
        position: "bottom",
      },  
      // datalabels: {
      //   color: "black",
      //   textStrokeColor: "white",
      //   textStrokeWidth: 4,
      //   anchor: "end",
      //   align: "end",
      //   // rotation: 90, 
      //   // display: "auto",
      //   // clip: "auto",
      //   font: {
      //     weight: "bold",
      //     size: 10,
      //   },
      // },
      datalabels: {
        display:false
      },
    },
    scales: {
      x: {
        stacked: true,
        display: true,
        fontWeight: "bold",
        ticks: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
      y: {
        stacked: "normalized",
        display: true,
        fontWeight: "bold",
        ticks: {
          display: true,
        },
        grid: {
          display: true,
        },
      },
      y1: {
        stacked: "normalized",
        display: false,
        position: "right",
        fontWeight: "bold",
        // min: 0,
        // max: 700,
        ticks: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
    },
  };
  return (
    <div style={{ height: "300px", width: "100%" }}>
      <Chart data={data} options={options} />
    </div>
  );
};

export default RevenueBusinessBarLineChart;